module.exports = __webpack_public_path__ + "img/card-print.3e12df51.png";